module.exports = __webpack_public_path__ + "img/environment_indoor7.cbb15f33.jpg";